import React, { useEffect } from 'react'
import { NewWebFooter } from './common/NewWebFooter'
import Slider from 'react-slick'
import NewWebHeader from "./common/NewWebHeader.jsx";
import $ from "jquery";
import { Link } from 'react-router-dom';

export const CheckboxThank = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    $(window).scroll(function () {
        if ($(this).scrollTop() > 30) {
            $('body').addClass('newClass');
        } else {
            $('body').removeClass('newClass');
        }
    });
    function SimpleNextArrow(props) {
        const { onClick } = props;
        return (
            <>
                <div className="nextArrow" onClick={onClick}>
                    <span class="next-arrows slick-arrow">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </div>
            </>
        );
    }

    function SimplePrevArrow(props) {
        const { onClick } = props;
        return (
            <>
                <div className="prevArrow" onClick={onClick}>
                    <span class="prev-arrows slick-arrow">
                        {" "}
                        <i class="fa fa-angle-left" aria-hidden="true"></i>{" "}
                    </span>
                </div>
            </>
        );
    }
    const sliderSettings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        autoplay: true,

        prevArrow: <SimplePrevArrow />,
        nextArrow: <SimpleNextArrow />,


        responsive: [{
            breakpoint: 1200,
            settings: {
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 993,
            settings: {
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 600,
            settings: {
                autoplay: false,
                speed: 100,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 400,
            settings: {
                arrows: false,
                speed: 100,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
            }
        }]
    }
    return (
        <div>
            <div classname="newabout">
                <NewWebHeader newabout={"newabout"} />
            </div>
            <section class="about-page-section blog-section payment-sect pb-0" style={{ paddingBottom: "0px !important" }}>

                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center align-items-center" style={{ pointerEvents: "none" }}>

                        </div>

                    </div>
                    <div className="row  justify-content-center ">
                        <div className="col-md-8 col-12 col-sm-12 col-xl-8 col-xxl-8">
                            <div className="card-payment-methods">
                                <div class="heading-title m-sm-0">
                                    <p>
                                        <span></span>{" "}
                                    </p>
                                    <h2>Fill The Form</h2>
                                </div>
                                <div className="para-proceed">
                                    <form action="" className='form-checkbox'>
                                        <div className="row">
                                            <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12 mb-2">
                                                <input type="checkbox" />
                                                <label htmlFor="">I Want to know more about it</label>
                                            </div>
                                            <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12 mb-2">
                                                <input type="checkbox" />
                                                <label htmlFor="">I want to work with you</label>
                                            </div>
                                            <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12 mb-2">
                                                <input type="checkbox" />
                                                <label htmlFor="">I am excited to invest in your startups</label>
                                            </div>
                                            <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12 mt-2">
                                            <textarea id="w3review" name="" rows="4" className='w100' placeholder='Message'/>
                                               
                                            </div>
                                        </div>
                                    </form>
                                   
                                </div>
                                <div className="button-proceed-online">
                                    <a href="Thankyou">Submit</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </section>




            <NewWebFooter />

        </div>
    )
}
